const vowels = 'AEIOUYaeiouy'.split('');
const hardVowels = 'AOUaou'.split('');
const softVowels = 'EIYeiy'.split('');

const endWithSubstitutions = [['ck', 'K']];
const preSubstitutions = [
  ['oo', 'OU'],
  ['ee', 'I'],
];
const substitutions = [
  ['eau', 'O'],
  ['au', 'O'],
  ['ch', 'CH'],
  ['ck', 'CH'],
  ['cc', 'K'],
  ['y', 'I'],
  ['dj', 'J'],
  ['ks', 'X'],
  ['pt', 'T'],
  ['ph', 'F'],
  ['h', ''],
];

export function sanitize(str) {
  return str
    .toLowerCase()
    .replaceAll('ç', 'S')
    .replace(/\p{Diacritic}+/gu, '_')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[^a-zA-Z]+/gu, '');
}

function splice(str, pos, len, replace = '') {
  return str.slice(0, pos) + replace + str.slice(pos + len);
}

const shouldLog = false;
function log() {
  shouldLog && console.log.apply(null, arguments);
}

export function phonetic(original) {
  log(original);
  let name = sanitize(original);
  let endSubstituted = false;
  for (const sub of preSubstitutions) {
    name = name.replaceAll(sub[0], sub[1]);
  }
  for (const sub of endWithSubstitutions) {
    if (name.endsWith(sub[0])) {
      name = name.slice(0, -sub[0].length) + sub[1];
      endSubstituted = true;
      break;
    }
  }
  for (const sub of substitutions) {
    name = name.replaceAll(sub[0], sub[1]);
  }
  let res = '';
  for (let i = 0; i < name.length; i++) {
    const prev = name[i - 1];
    const next = name[i + 1];
    const next2 = name[i + 2];
    const end = endSubstituted && next;
    const c = name[i];
    if (c === 's' && vowels.includes(prev) && !end) {
      //continue;
    }
    if (c === 's' && vowels.includes(prev) && vowels.includes(next)) {
      res += 'Z';
      continue;
    }
    if (c === 'g') {
      if (next === 'e' && hardVowels.includes(next2)) {
        res += 'J';
        i++;
        continue;
      }
      if (softVowels.includes(next)) {
        res += 'J';
        continue;
      }
    }
    if (c === 'c') {
      if (softVowels.includes(next)) {
        res += 'S';
      } else {
        res += 'K';
      }
      continue;
    }
    if (c.toUpperCase() === next?.toUpperCase()) {
      i++;
    }
    res += c.toUpperCase();
  }

  const endWithE = res.endsWith('E') && !['A', 'O'].includes(res[res.length - 2]);
  if (endWithE) {
    res = res.slice(0, -1);
  }

  let res2 = '';
  for (let i = 0; i < res.length; i++) {
    const next = res[i + 1];
    const c = res[i];
    if (c.toUpperCase() === next?.toUpperCase()) {
      i++;
    }
    res2 += c.toUpperCase();
  }

  return res2;
}
